<template>
  <div
    class="circular-wrapper"
    style="padding-top: 3px; padding-right: 3px; padding-left: 3px;"
  >
    <svg
      :width="size"
      :height="size"
      class="progress-ring"
    >
      <!-- Background circle -->
      <circle
        class="progress-ring__bg"
        :stroke="backgroundColor"
        :stroke-width="stroke"
        fill="transparent"
        :r="radius"
        :cx="center"
        :cy="center"
      />

      <!-- Progress circle -->
      <circle
        class="progress-ring__circle"
        :stroke="toHexString(variant)"
        :stroke-width="stroke"
        fill="transparent"
        :r="radius"
        :cx="center"
        :cy="center"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
      />
    </svg>

    <div
      class="progress-text"
      :style="{
        fontSize: '10px',
        color: toHexString(variant)
      }"
    >
      {{ percentage }}%
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircularProgress',
  props: {
    value: { type: Number, required: true },
    max: { type: Number, default: 100 },
    size: { type: Number, default: 120 },
    stroke: { type: Number, default: 5 },
    variant: { type: String, default: 'success' },
    backgroundColor: { type: String, default: '#e5e5e5' }
  },

  data () {
    return {
      colors: {
        primary: '#00a5fe',
        success: '#06C270',
        warning: '#ffa500',
        danger: '#ff0000',
        dark: '#737373'
      }
    }
  },
  computed: {
    percentage () {
      const percent = (this.value / this.max) * 100
      return Math.max(0, Math.round(percent))
    },
    center () {
      return this.size / 2
    },
    radius () {
      return (this.size - this.stroke) / 2
    },
    circumference () {
      return 2 * Math.PI * this.radius
    },
    dashOffset () {
      return this.circumference * (1 - Math.min(100, this.percentage) / 100)
    }
  },
  methods: {
    toHexString (color) {
      return this.colors[color]
    }
  }
}
</script>

<style scoped>
.circular-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.progress-ring {
  transform: rotate(-90deg);
}

.progress-ring__circle {
  transition: stroke-dashoffset 0.4s ease;
  stroke-linecap: round;
}

.progress-text {
  position: absolute;
  font-weight: 500;
  /* font-size: 12px; */
}
</style>
